import { useCardData } from "./useCardData";
import { useBarChartData } from "./useBarChartData";
import { useMatrixChartData } from "./useMatrixChartData";
import { usePieChartData } from "./usePieChartData";
import { useRadarChartData } from "./useRadarChartData";

/**
 * Facade composable — composes question data, bar, matrix/stacked, and pie
 * sub-composables into a single return object for backward compatibility.
 *
 * Backend shape (per question):
 *   { respondents, answers: { code: { percentage, nb, title, significance, ... } } }
 *
 * Population data is stored at:
 *   chartsData[questionId]           → "All" population (top-level)
 *   chartsData[questionId].pop_X     → additional population X
 */
export function useChartData(card, localOptions = null) {
  const ctx = useCardData(card, localOptions);

  const { populationsBarData, matrixItemsBarData, populationRespondents } = useBarChartData(ctx);
  const { stackedData, matrixChoiceCodes, matrixChoiceLabels, matrixTableData } =
    useMatrixChartData(ctx, { populationsBarData });
  const { pieData } = usePieChartData(ctx);
  const { radarAxes, radarSeries, radarScale } = useRadarChartData(ctx);

  return {
    questionMeta: ctx.questionMeta,
    effectiveQuestionId: ctx.effectiveQuestionId,
    cardType: ctx.cardType,
    codeLabels: ctx.codeLabels,
    isMatrix: ctx.isMatrix,
    isMatrixMultiple: ctx.isMatrixMultiple,
    cardName: ctx.cardName,
    populationsBarData,
    matrixItemsBarData,
    stackedData,
    matrixChoiceCodes,
    matrixChoiceLabels,
    pieData,
    radarAxes,
    radarSeries,
    radarScale,
    matrixTableData,
    respondents: ctx.respondents,
    populationRespondents,
    displayedPopulations: ctx.matrixPopulations,
    singlePopulation: ctx.singlePopulation,
    shouldIncludeWeights: ctx.shouldIncludeWeights,
    title: ctx.title,
    activeIteration: ctx.activeIteration,
    loopIterationOptions: ctx.loopIterationOptions,
    showSentiment: ctx.showSentiment,
    isNumeric: ctx.isNumeric,
    numericStats: ctx.numericStats,
  };
}
